/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBindOkxWallet.vue?vue&type=template&id=464e388b&scoped=true"
import script from "./popBindOkxWallet.vue?vue&type=script&lang=js"
export * from "./popBindOkxWallet.vue?vue&type=script&lang=js"
import style0 from "./popBindOkxWallet.vue?vue&type=style&index=0&id=464e388b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464e388b",
  null
  
)

export default component.exports